// Deep link to the page that shows one pillar post, per edition (PLAN.md §3.1 item 5, filled by part B1).
// Agencies ALWAYS keep today's target (/pillar-posts?post=), which also stays valid for old mails and Lina
// chat links. Hotels open the module of the post's media format — but only a module that is live for them
// (edition.modules); otherwise the old target.
import { hasEditionModule, type Edition } from "./edition.js";
import { effectiveMediaFormat } from "./pillarFormats.js";

export interface PostRouteTarget {
  /** pillar_posts.id */
  id: string;
  platform?: string | null;
  /** pillar_posts.media_format (foto / karussell / reel / linkedin); NULL/absent = derived from platform */
  mediaFormat?: string | null;
}

export function legacyPillarPostHref(id: string): string {
  return `/pillar-posts?post=${id}`;
}

function hotelPostHref(post: PostRouteTarget, edition: Edition): string {
  const format = effectiveMediaFormat(post);
  if ((format === "foto" || format === "karussell") && post.platform === "instagram" && hasEditionModule(edition, "fotos")) {
    return `/instagram-fotos?post=${post.id}`;
  }
  if (format === "reel" && post.platform === "instagram" && hasEditionModule(edition, "reels")) {
    return `/instagram-reels?post=${post.id}`;
  }
  if (format === "linkedin" && post.platform === "linkedin" && hasEditionModule(edition, "linkedin")) {
    return `/linkedin-beitraege?post=${post.id}`;
  }
  return legacyPillarPostHref(post.id);
}

export function postModuleHref(post: PostRouteTarget, edition: Edition | null | undefined): string {
  if (edition?.kind === "hotel") return hotelPostHref(post, edition);
  return legacyPillarPostHref(post.id);
}
